<template>
  <v-app>
    <v-app-bar dense app elevation="3" id="mainToolbar">
      <v-row align="center" no-gutters>
        <v-col
          cols="12"
          md="8"
          offset-md="2"
          lg="6"
          offset-lg="3"
          xl="4"
          offset-xl="4"
        >
          <div class="d-flex align-center">
            <v-icon color="primary" left>fas fa-clipboard-list-check</v-icon>
            <v-app-bar-title class="subtitle-2 font-weight-bold">
              แบบประเมินทดสอบความสามารถ
            </v-app-bar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeWebView">
              <v-icon small>far fa-times</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>

    <v-overlay v-model="overlay">
      <div class="text-center">
        <v-progress-circular
          color="white"
          size="64"
          indeterminate
        ></v-progress-circular>
        <div class="title mt-4">{{ overlayOpts.msg || "กำลังดำเนินการ" }}</div>
      </div>
    </v-overlay>

    <v-dialog v-model="internalBrowser" fullscreen hide-overlay>
      <v-card tile>
        <v-toolbar dense color="primary" dark flat>
          <v-btn dark icon @click="closeInternalBrowser">
            <v-icon>far fa-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title class="caption pl-0"
            >URL: {{ internalBrowserUrl }}</v-toolbar-title
          >
        </v-toolbar>
        <v-row class="fill-height">
          <iframe
            :src="internalBrowserUrl"
            frameborder="0"
            height="100%"
            width="100%"
            style="height: calc(100vh - 48px)"
          ></iframe>
        </v-row>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import EventBus from "../plugins/event-bus";
export default {
  data: () => ({
    overlay: false,
    overlayOpts: {},
    internalBrowser: false,
    internalBrowserUrl: "",
  }),
  created() {
    EventBus.$on("overlay", this.overlayHandler);
    EventBus.$on("internalBrowser", (url) => {
      this.openExternalBrowser(url);
    });
  },
  beforeDestroy() {
    EventBus.$off("overlay");
    EventBus.$off("internalBrowser");
  },
  methods: {
    overlayHandler(val, opts) {
      this.overlayOpts = opts || {};
      this.overlay = val;
    },
    openExternalBrowser(url) {
      if (typeof externalBrowser !== "undefined") {
        externalBrowser.postMessage(url);
      } else {
        window.open(url, "_blank");
      }
    },
    closeInternalBrowser() {
      this.internalBrowserUrl = "";
      this.internalBrowser = false;
    },
    closeWebView() {
      EventBus.$emit("closeWebView");
    },
  },
};
</script>

<style lang="scss" scoped>
#mainToolbar ::v-deep div.v-toolbar__content {
  padding-right: 0px;
}
</style>